import React, { useEffect, useState } from "react";
import "../../../forms-style.scss";
import { Dropdown } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { ROUTE_CONSTANT } from "../../../Util/Constants";
import { readCookie, navigateToSignleLoginAPP } from "../../../Util/helper";
import { TemplateObject } from "../../../Models/TemplateObject";
import SingleSignOnService from "../../../Services/SingleSignOnService";
import { ProcessLogout } from "../../../Util/Process-Logout";
import { useParams } from "react-router-dom";
import {
  goToDashboardAfterDownload,
  goToDashboardSettings,
} from "../../../Util/DownloadHelper";
type Props = {};
type callBackProps = {
  callBack?: (p: string) => void;
};

const MyAccount = ({ callBack }: callBackProps) => {
  const ddOnclickHandler = (_index: any) => {
    let selectedDD = _index.target.id;
    if (selectedDD == "ddSettings") {
      callBack?.("ddSettings");
    } else if (selectedDD == "ddSignout") {
      callBack?.("ddSignout");
    } else if (selectedDD == "goToDashboard") {
      callBack?.("goToDashboard");
    }
  };
  return (
    <>
      {" "}
      <div className="show">
        <div className="account-menu navbar-menu">
          <Dropdown>
            <Dropdown.Toggle
              aria-hidden="true"
              id="my_account"
              variant="btn btn-outline-primary btn-sm navbar-btn btn my-account-btn"
            >
              <span className="bars-hidden-cls">
                <i className="fa fa-bars menu-bars" aria-hidden="true"></i>
              </span>
              <span className="dropdown-btn-hide">My account</span>
            </Dropdown.Toggle>

            <Dropdown.Menu onClick={ddOnclickHandler}>
              <Dropdown.Item id="ddSettings">Settings</Dropdown.Item>

              <Dropdown.Item id="goToDashboard">Go to dashboard</Dropdown.Item>
              <Dropdown.Item eventKey="3" id="ddSignout">
                <i className="fa fa-sign-out" aria-hidden="true"></i>
                Sign Out
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    </>
  );
};
const TopBtnGroup = (props: Props) => {
  const [isSignupOrSignIn, setIsSignupOrSignIn] = useState(false);
  const [planNav, setPlanNav] = useState(false);
  const [checkoutNav, setCheckoutNav] = useState(false);
  const [completedNav, setCompletedNav] = useState(false);
  const currentPath = window.location.pathname;
  const topBtnGroupCallback = (fieldValue: any) => {
    // if (fieldValue == "ddSettings") {
    //   navigate(pathRedirectSettings.next);
    // }
    let portal = "PS";
    if (fieldValue == "ddSignout") {
      // SingleSignOnService.partnerLogOut(portal).then((resp: any) => {
      //   console.log("sign out")
      // }).catch((error) => { });
      ProcessLogout("", "", "", "");
    } else if (fieldValue == "ddSettings") {
      goToDashboardSettings();
    } else if (fieldValue == "goToDashboard") {
      goToDashboardAfterDownload(true);
    }
  };
  useEffect(() => {
    const page = window.location.pathname.split("/").pop();
    switch (page) {
      case "sign-in":
      case "sign-up":
        setIsSignupOrSignIn(true);
        break;
      case "plans":
        setPlanNav(true);
        setCheckoutNav(false);
        break;
      case "checkout":
        setPlanNav(true);
        setCheckoutNav(true);
        break;
      case "confirmation":
        setPlanNav(true);
        setCheckoutNav(true);
        setCompletedNav(true);
        break;
      default:
        break;
    }
  }, [currentPath]);
  return (
    <>
      <div className="main-content">
        <div className="sign-menu navbar-menu">
          {planNav ? (
            <>
              <ul className="steps">
                <li>
                  <a className="active" href="#">
                    <i className="fa fa-check"></i> Document Completed
                  </a>
                </li>
                <li>
                  <a className={planNav === true ? "active" : ""} href="#">
                    <i className="fa fa-check"></i> Plan
                  </a>
                </li>
                <li>
                  <a
                    id="stepPayment"
                    className={checkoutNav === true ? "active" : ""}
                    href="#"
                  >
                    <i className="fa fa-check"></i> Payment Details
                  </a>
                </li>
                <li>
                  <a
                    id="stepComplete"
                    className={completedNav === true ? "active" : ""}
                    href="#"
                  >
                    <i className="fa fa-check"></i> Completed
                  </a>
                </li>
              </ul>
            </>
          ) : (
            <>
              {isSignupOrSignIn && (
                <>
                  <div>
                    {/* <Button id="help-guid" variant="btn btn-outline-primary btn-sm navbar-btn help-guid-desktop">
                      Help Guide
                    </Button> */}
                    <div className="help-guid-mobile">
                      <Dropdown>
                        <Dropdown.Toggle
                          aria-hidden="true"
                          id="my_account"
                          variant="btn btn-outline-primary btn-sm navbar-btn help-guid-mobile-btn"
                        >
                          <span className="bars-hidden-cls">
                            <i
                              className="fa fa-bars menu-bars"
                              aria-hidden="true"
                            ></i>
                          </span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="mobile-dropdown">
                          <Dropdown.Item href="#/action-1" className="">
                            Helpguide
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                </>
              )}
              {!isSignupOrSignIn && (
                <>
                  {!!readCookie("jwtToken") || !!readCookie("refreshToken") ? (
                    <MyAccount callBack={topBtnGroupCallback} />
                  ) : (
                    <a
                      href={"/app/account/signup"}
                      className="btn btn-outline-primary btn-sm navbar-btn signup-btn"
                    >
                      Member Login
                    </a>
                  )}
                </>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};
export default TopBtnGroup;
